var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShareIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.05286 10.1141C10.0944 11.1556 10.0944 12.8443 9.05286 13.8858C8.01133 14.9273 6.32268 14.9273 5.28115 13.8858C4.23962 12.8443 4.23962 11.1556 5.28115 10.1141C6.32268 9.07256 8.01133 9.07256 9.05286 10.1141",
    stroke: "#FFFEFE",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7189 4.78115C20.7604 5.82268 20.7604 7.51133 19.7189 8.55286C18.6773 9.59439 16.9887 9.59439 15.9472 8.55286C14.9056 7.51133 14.9056 5.82268 15.9472 4.78115C16.9887 3.73962 18.6773 3.73962 19.7189 4.78115",
    stroke: "#FFFEFE",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7189 15.4471C20.7604 16.4886 20.7604 18.1773 19.7189 19.2188C18.6773 20.2603 16.9887 20.2603 15.9472 19.2188C14.9056 18.1773 14.9056 16.4886 15.9472 15.4471C16.9887 14.4056 18.6773 14.4056 19.7189 15.4471",
    stroke: "#FFFEFE",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.53906 10.81L15.4591 7.84998",
    stroke: "#FFFEFE",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.53906 13.19L15.4591 16.15",
    stroke: "#FFFEFE",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareIcon);
export default __webpack_public_path__ + "static/media/share-icon.6712d40499419588b2a01a1172ea8fd3.svg";
export { ForwardRef as ReactComponent };